import React, { useState, useRef, useEffect } from 'react'

import { BeaconSetSuggestions } from '../Components/BeaconDialogMap';
import { v4 as uuid } from "uuid";

import Select from 'react-select'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import FormCheck from 'react-bootstrap/FormCheck'
import CSVUploader from '../Components/CSVUploader'
import InputGroup from 'react-bootstrap/InputGroup'
import * as Constants from '../constants.js'
import { parse } from '@vanillaes/csv'
import { ToastError, ToastLoading, ToastSuccess } from '../Components/ToastDisplay'

import { CreateAnnotationWithCrs } from '../Api/AnnotationApi.js'

import '../css/annotation-properties.css'
import '../ProjectsPage/list-style.css'
import '../css/modal.css'


import { Logger } from 'aws-amplify';
const logger = new Logger('ImportAnnotations');

function getCrsTitle(crs, model) {
    if (crs.IsNative) {
        return "[Native CRS] " + model.Title;
    }
    else {
        return crs.Title;
    }
}

function CrssToOptions(crss, model) {
    return crss?.map(c => ({ value: c.CrsId, label: getCrsTitle(c, model) }));
}

//create your forceUpdate hook
function useForceUpdate() {
    // eslint-disable-next-line no-unused-vars
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
}



function ValuePropertyItem(itemProps) {

    const [valid, setValid] = useState(true);
    const [value, setValue] = useState(itemProps.property.Value);

    function handleChange(event) {
        itemProps.property.Value = event.target.value;
        itemProps.property.valueHasBeenEdited = true;
        validateChange(event.target.value)
        setValue(event.target.value);
    }

    function validateChange(value) {


        //text
        if (itemProps.property.PropertyTemplate.ValueType === 0 || value === "") {
            setValid(true);
        }
        //int
        else {
            let num = Number(value);
            const isValid = !isNaN(num) && value !== "";
            try {
                itemProps.transformStep.isInvalid = !isValid;
            }
            catch (e) { }

            setValid(isValid);
        }

    }

    useEffect(() => {
        validateChange(itemProps.property.Value);
    });

    return (
        <div className={"annotationPropertyItemContainer m-2 p-2 border rounded border-dark annotationPropertyItemContainerBackgroundLight"} >
            <div className="annotationPropertyItemLabel">
                {itemProps.property.PropertyTemplate.Title}
            </div>
            <div className="annotationPropertyItemValue">
                <InputGroup hasValidation>
                    <InputGroup.Text size="sm">{"Value"}</InputGroup.Text>
                    <Form.Control
                        className={"annotationPropertyItemContainerBackgroundLight"}
                        type="text"
                        name="a"
                        isInvalid={!valid}
                        value={value}
                        onChange={handleChange} />
                </InputGroup>
            </div>
        </div>
    );
}

function ListPropertyItem(props) {

    const [parameterList, setParameterList] = useState(ListItemsToOptions(props?.property?.Items));

    function getClassNameContainer() {
        return "annotationPropertyItemContainerBackgroundLight"
    }
    function getValueColour() {
        return '#ffffff';
    }

    function setItems(items) {
        setParameterList(items);

        props.property.Items = OptionsToListItems(items);
        props.property.valueHasBeenEdited = true;

        if (props.onPropertyChange) {
            props.onPropertyChange(props.property);
        }
    }

    function ListItemsToOptions(listItems) {
        if (listItems) {
            if (listItems.length) {
                return listItems.map(item => ({ label: item.ItemText, value: item.ListPropertyTemplateListItemId }));
            } else if (listItems.ItemText) {
                return [{ label: listItems.ItemText, value: listItems.ListPropertyTemplateListItemId }];
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    function OptionsToListItems(options) {
        if (options) {
            if (options.length) {
                return options.map((item, index) => ({ ItemText: item.label, ListPropertyTemplateListItemId: item.value, Order: index }));
            } else if (options.label) {
                return [{ ItemText: options.label, ListPropertyTemplateListItemId: options.value, Order: 0 }];
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }


    return (
        <div className={"annotationPropertyItemContainer m-2 p-2 border rounded border-dark " + getClassNameContainer()}>
            <div className="annotationPropertyItemLabel">
                {props.property?.PropertyTemplate.Title}
            </div>
            <div className="annotationPropertyItemValue">
                <Select
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        control: base => ({ ...base, backgroundColor: getValueColour() })
                    }}
                    value={parameterList}
                    onChange={setItems}
                    closeMenuOnSelect={props.property.PropertyTemplate.MultiSelect ? false : true}
                    name="parameterList"
                    className={"basic-multi-select "}
                    isMulti={props.property.PropertyTemplate.MultiSelect}

                    placeholder={props.property.PropertyTemplate.MultiSelect ? "Select Item(s)..." : "Select Item..."}
                    options={ListItemsToOptions(props.property.PropertyTemplate.ListItems)} />

            </div>
        </div>
    );
}


function PropertyComponent(props) {
    switch (props.property.PropertyTemplate.PropertyType) {

        //value
        case 0:
            return <ValuePropertyItem {...props} />
        //list
        case 1:
            return <ListPropertyItem {...props} />
        default:
            return <></>
    }
}

function PropertyListRow(props) {
    return (
        <PropertyComponent property={props.property} />
    );
}

function PropertiesList(props) {


    const { properties, firstColIsLabel, firstColumnPropertyTemplate, forceUpdate } = props;

    return (

        <div className="styleRuleList">

            <ul className={"propsList"}>
                {properties?.filter(
                    p => p.PropertyTemplateId !== firstColumnPropertyTemplate?.value || !firstColIsLabel)?.map(
                        (property, index) => {
                            return (
                                <li key={property.PropertyTemplateId} className="selectionContainer">
                                    <input
                                        className="selectionCheckbox"
                                        id={property.PropertyTemplateId}
                                        type='checkbox'
                                        checked={property?.Selected}
                                        onChange={(event) => {
                                            if (event.target.checked) {
                                                property.Selected = true;
                                                forceUpdate();
                                            } else {
                                                property.Selected = false;
                                                forceUpdate();
                                            }
                                        }}
                                    />
                                    <PropertyListRow property={property} />
                                </li>
                            );
                        })}
            </ul>
        </div>
    );
}

export function ImportAnnotations(props) {
    logger.debug("props", props);

    const toastId = useRef();

    const { show, setShow, annotationSet, project, model, helpContext, parentHelpContext } = props;

    const form = useRef(null);

    const [validated, setValidated] = useState(false);
    const [uiDisabled, setUiDisabled] = useState(false);

    const [selectedFile, setSelectedFile] = useState();
    const [selectedFileValid, setSelectedFileValid] = useState(false);
    const [properties, setProperties] = useState([]);
    const [csvData, setCsvData] = useState();
    const [csvDataValid, setCsvDataValid] = useState(true);
    const [firstLineIsHeader, setFirstLineIsHeader] = useState(false);
    const [firstColIsLabel, setFirstColIsLabel] = useState(true);
    const [firstColumnPropertyTemplate, setFirstColumnPropertyTemplate] = useState();
    const [annotationQueue, setAnnotationQueue] = useState([]);

    const [availableCrssOptions, setAvailableCrssOptions] = useState([]);
    const [defaultCrsOption, setDefaultCrsOption] = useState(null);
    const forceUpdate = useForceUpdate();

    //detect parsed csv data and validate
    React.useEffect(() => {

        if (annotationQueue.length > 0) {

            ToastLoading("Annotations remaining: " + annotationQueue.length, toastId.current);

            let anQu = JSON.parse(JSON.stringify(annotationQueue));
            let an = anQu.shift();
            //pull the first item out of the queue
            CreateAnnotationWithCrs(an, defaultCrsOption?.value)
                .then(res => {
                    //remove the annotation from the queue and trigger the next
                    if (anQu.length > 0) {
                        setAnnotationQueue(anQu);
                    }
                    else {
                        setAnnotationQueue(anQu);
                        setCsvData(null);
                        setSelectedFile(null);
                        ToastSuccess("Annotation import finished", toastId.current, 2000);
                        setUiDisabled(false);
                        setShow(false);
                    }

                })
                .catch(err => {
                    ToastError(err.message, err.cause, toastId.current);
                    setUiDisabled(false);
                });


        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [annotationQueue])


    React.useEffect(() => {
        if (show) {

            if (!properties.length) {

                //add properties for all the templates in the anset
                let propList = [];

                project?.PropertyTemplates.forEach(template => {

                    let property = {
                        PropertyType: template.PropertyType,
                        ProjectId: project.ProjectId,
                        PropertyTemplateId: template.PropertyTemplateId,
                        PropertyTemplate: template,
                        Selected: false
                    };

                    if (template.PropertyType === Constants.propertyType.Value) {
                        property.Value = "";

                        propList.push(property);
                    }
                    else if (template.PropertyType === Constants.propertyType.List) {

                        property.Items = [];
                        propList.push(property);
                    }


                })

                setProperties(propList);
            }

            setAvailableCrssOptions(CrssToOptions(model?.CRSs, model));

            BeaconSetSuggestions(helpContext);
        }
        else {
            BeaconSetSuggestions(parentHelpContext);

            setSelectedFile(null);
            setProperties([]);
            setCsvData(null);
            setAnnotationQueue([]);
            setValidated(false);
            setDefaultCrsOption(null);
            setFirstColumnPropertyTemplate(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [helpContext, parentHelpContext, show])


    //detect file is selected - load into csvData
    React.useEffect(() => {
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = function (e) {
                const content = e.target.result;
                setCsvData(parse(content));
            };
            reader.readAsText(selectedFile);
        }
    }, [selectedFile])



    function onClose() {
        setShow(false);
    }

    function onSave(event) {

        event.preventDefault();

        const fileValid = csvData;
        setSelectedFileValid(fileValid);

        //check we have 4 columns
        let csvValid = true;
        csvData?.forEach((row, rowIndex) => {
            if (row.length !== 4 && row.length !== 1) {//allow single column rows (probably a blank line)
                csvValid = false;
            }
            row.forEach((item, colIndex) => {
                //valid number in columns 1, 2, 3 and ignore first row if header row
                if (!(rowIndex === 0 && firstLineIsHeader) && colIndex !== 0 && isNaN(item)) {
                    csvValid = false;
                }
            });
        });
        setCsvDataValid(csvValid);

        if (defaultCrsOption && fileValid && csvValid && ((firstColumnPropertyTemplate && firstColIsLabel) || !firstColIsLabel)) {

            toastId.current = ToastLoading("Creating annotations");

            setUiDisabled(true);

            //add annotaions to the queue
            let newAnnotationQueue = [];
            csvData.forEach((row, index) => {
                if (row.length === 4 && !(index === 0 && firstLineIsHeader)) {

                    let anid = uuid();

                    let newAnnotation = {
                        AnnotationId: anid,
                        AnnotationSetId: annotationSet.AnnotationSetId,
                        Position: { x: row[1], y: row[2], z: row[3] },
                        Properties: properties.filter((property) => (property?.Selected === true) || (firstColIsLabel && firstColumnPropertyTemplate?.value === property.PropertyTemplateId)).map(property => {
                            let newProperty = JSON.parse(JSON.stringify(property));
                            newProperty.PropertyId = uuid();
                            newProperty.AnnotationId = anid;
                            if (firstColIsLabel && firstColumnPropertyTemplate?.value === property.PropertyTemplateId) {
                                newProperty.Value = row[0];
                            }

                            return newProperty;
                        })
                    };
                    newAnnotationQueue.push(newAnnotation);
                }
            });
            setAnnotationQueue(newAnnotationQueue);

        }
        else {
            //failed validation
            event.stopPropagation();
        }

        setValidated(true);
    }

    function maxFileSizeBytes() {
        return 10 * 1024 * 1024; //10MB
    }

    function TextValuePropertySelector(props) {

        let parameterList =
            props?.project?.PropertyTemplates.filter(
                t => ((t.PropertyType === Constants.propertyType.Value) && (t?.ValueType === Constants.valueType.TextProperty))).map(
                    item => ({ label: item.Title, value: item.PropertyTemplateId }));
        return (
            <Select
                value={firstColumnPropertyTemplate}
                onChange={setFirstColumnPropertyTemplate}
                closeMenuOnSelect={true}
                name="parameterList"
                className={"basic-multi-select "}
                isMulti={false}

                placeholder={"Select text property..."}
                options={parameterList} />

        );
    }






    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            keyboard={false}
            centered
            dialogClassName="modal-900w"
        >
            <div class="modal-header" >
                <h4 class="modal-title">{"Import Annotations to [" + annotationSet?.Title + "]"}
                    <br />
                    <div className="subtitle">Import annotations to this annotation set from a .cvs file.<br />
                        There must be 4 columns: Label, x, y z. In that order.<br />
                        You may assign the label to a text value property.<br />
                        Selected properties will be assigned to every annotation imported. (They can be left blank.)<br />
                    </div>
                </h4>
            </div>
            <Modal.Body>
                <Container className="mx-2 my-2">
                    <Row className="border-bottom-only pb-2">
                        <Form ref={form} noValidate validated={validated} onSubmit={onSave}>

                            <Form.Group controlId="formGroupModelFile" as={Row}>
                                <Col>
                                    <Form.Label >CSV File:</Form.Label>
                                    <CSVUploader maxFileSize={maxFileSizeBytes()} selectedFile={selectedFile} setSelectedFile={setSelectedFile} />

                                    {(!selectedFileValid && validated) &&
                                        <Form.Text className="text-danger">
                                            Please select a .csv to import.
                                        </Form.Text>
                                    }
                                    {(!csvDataValid) &&
                                        <Form.Text className="text-danger">
                                            There must be 4 columns in every row. Last 3 columns must contain numbers.
                                        </Form.Text>
                                    }
                                    <Row>
                                        <Form.Label column sm={8} >First row is header (so ignore):</Form.Label>
                                        <Col sm={2}>
                                            <FormCheck
                                                className="mt-2"
                                                type="switch"
                                                id="isPositive"
                                                label=""
                                                checked={firstLineIsHeader}

                                                onChange={(e) => setFirstLineIsHeader(!firstLineIsHeader)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Form.Label column sm={8} >Assign first column to a text property:</Form.Label>
                                        <Col sm={2}>
                                            <FormCheck
                                                className="mt-2"
                                                type="switch"
                                                id="isPositive"
                                                label=""
                                                checked={firstColIsLabel}

                                                onChange={(e) => setFirstColIsLabel(!firstColIsLabel)}
                                            />
                                        </Col>
                                    </Row>
                                    {firstColIsLabel &&
                                        <Row>
                                            <Col >
                                                <TextValuePropertySelector project={props.project} />
                                            </Col>
                                            {(!firstColumnPropertyTemplate && validated) &&
                                                <Form.Text className="text-danger">
                                                    Please select a property.
                                                </Form.Text>
                                            }
                                        </Row>
                                    }
                                    <Row>
                                        <Form.Label column sm={4}>Coordinates CRS:</Form.Label>
                                        <Col sm={8}>
                                            <Select
                                                value={defaultCrsOption}
                                                onChange={setDefaultCrsOption}
                                                closeMenuOnSelect={true}
                                                name="groups"
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Click to Select default CRS..."
                                                options={availableCrssOptions}
                                                isDisabled={false}
                                            />
                                        </Col>
                                        {(!defaultCrsOption && validated) &&
                                            <Form.Text className="text-danger">
                                                Please select a CRS.
                                            </Form.Text>
                                        }
                                    </Row>


                                </Col>
                                <Col>
                                    <Form.Label >Selected properties will be added to all imported annotations:</Form.Label>
                                    <PropertiesList properties={properties} forceUpdate={forceUpdate} firstColIsLabel={firstColIsLabel} firstColumnPropertyTemplate={firstColumnPropertyTemplate} />
                                </Col>

                            </Form.Group>

                        </Form>
                    </Row>

                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={uiDisabled} variant="primary" onClick={onSave}>OK</Button>
                <Button disabled={uiDisabled} variant="secondary" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>

    );


}